export default [
  'lg',
  'md',
  'sm',
  'xs',
];



// WEBPACK FOOTER //
// ./src-react/DesignSystem/Buttons/ButtonSizes.jsx